import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { Component as ComponentContainer } from '@styles/layout';
import { ImageComponent } from '@model/content';

const ContentImage = styled.img(({ theme }: ThemeProps) => ({
  margin: `${theme.custom.spacing.medium}px 0`,
  maxWidth: '100%'
}));

export const ImageContainer = ({ images }: ImageComponent) => {
  if (!images || !images.length) {
    return null;
  }
  return (
    <ComponentContainer>
      {images.map(({ url, title }) => (
        <ContentImage key={url} alt={title || ''} src={url} />
      ))}
    </ComponentContainer>
  );
};
